import React from 'react'
import DeletePatientButton from './DeletePatientButton'
import { Box } from '@mui/material'
import EditProcedureButton from './EditProcedureButton'
import ViewProcedureButton from './ViewProcedureButton'
import DiscussionNotesButton from './DiscussionNotesButton'
import { useAuth } from 'context/AuthContext'
import { EPermission } from 'enum/EPermission'

interface Props {
  id: number;
  hasNotes?: boolean;
  refetch?: () => void;
}

export default function ProcedureActionButtons({ id, hasNotes, refetch }: Props) {
  const { doctor } = useAuth();


  return (
    <Box
      display={'flex'}
      gap={1}
    >
      <ViewProcedureButton id={id} refetch={refetch} />

      {doctor?.permission != EPermission.VIEWER && <>
        <EditProcedureButton id={id} refetch={refetch} />
        <DiscussionNotesButton id={id} hasNotes={hasNotes} refetch={refetch} />
        <DeletePatientButton id={id} refetch={refetch} />
      </>}
    </Box>
  )
}
